import controllerConfigs from './controller.config';
import { useTranslation } from 'react-i18next';
import FormManager from '@app/components/EasyForm';
import AppDispatcher from '@app/events/app-commander';
import DomainModuleFactory from '@core/domain/index.module';
import { ComponentType, useEffect, useState, FormEvent } from 'react';

type IsFormValidListener = (isFormValid: boolean) => void;
class FormListener {
  private listener: IsFormValidListener | undefined;

  setFormStateListener(listener: IsFormValidListener): void {
    this.listener = listener;
  }

  onStateChangeAfter({ manager }) {
    const isFormFilledOK: boolean = manager.isFormFilledOK();
    if (this.listener) this.listener(isFormFilledOK);
  }
}

const listener = new FormListener();

export interface ActivateAccountRequestPageProps {
  isLoading: boolean;
  controllers: JSX.Element;
  t: (text: string) => string;
  handleOnSubmit: (ev: FormEvent) => void;
}

export default function activeAccountProvider(Page: ComponentType<ActivateAccountRequestPageProps>) {
  return function Adapted(props: any): JSX.Element {
    const { t } = useTranslation();
    const [isFormFilledOK, setIfFormFilledOK] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
      setIfFormFilledOK(formManager.isFormFilledOK());
      listener.setFormStateListener(isFormOk => setIfFormFilledOK(isFormOk));
    }, []);

    useEffect(() => {
      return activateAccountUseCase.abort;
    }, []);

    const handleOnSubmit = ev => {
      ev.preventDefault();

      setIsLoading(true);

      if (!formManager.isValid()) return;

      const { email, fiscalId, captchaToken } = formManager.getData();

      activateAccountUseCase
        .execute({ email, fiscalId, captchaToken })
        .then(() => AppDispatcher.visitPage({ path: '/active-account-instructions' }))
        .catch(({ code }) => AppDispatcher.showToast({ mode: 'error', message: code }))
        .finally(() => setIsLoading(false));
    };

    return <Page {...props} t={t} isLoading={isLoading} controllers={controllers} handleOnSubmit={handleOnSubmit} isFormFilledOK={isFormFilledOK} />;
  };
}

const activateAccountUseCase = DomainModuleFactory.auth().createRequestAccountActivationUseCase();

const defaultState = { email: '', fiscalId: '', captchaToken: '', acceptTermsConditions: false };
const formManager = new FormManager({ formIndex: 'active-account-request', defaultState, controllersHandlers: listener });
const controllers = formManager.initControllers(controllerConfigs);
